import React from 'react'
import { PageWrapper, SpacerProps } from '@tumelo/designsystem'
import styled, { css } from 'styled-components'
import { Header } from './Header'
import { LayoutWrapper } from './LayoutWrapper'

interface PageProps {
  children: React.ReactNode
  mainMarginTop?: SpacerProps
  mainMarginBottom?: SpacerProps
  columns?: boolean
}

export const PageLayout: React.FC<PageProps> = ({ children, mainMarginTop, mainMarginBottom, columns }) => {
  return (
    <LayoutWrapper>
      <Header />
      <div>
        <StyledPageWrapper center>
          <StyledMain $mainMarginTop={mainMarginTop} $mainMarginBottom={mainMarginBottom} $columns={columns}>
            {children}
          </StyledMain>
        </StyledPageWrapper>
      </div>
    </LayoutWrapper>
  )
}

const StyledMain = styled.main<{ $mainMarginTop?: SpacerProps; $mainMarginBottom?: SpacerProps; $columns?: boolean }>`
  margin-top: ${(props) => props.$mainMarginTop || '0'};
  margin-bottom: ${(props) => props.$mainMarginBottom || '0'};
  min-height: auto;
  ${({ $columns }) =>
    $columns &&
    css`
      height: 100%;
    `};
`

const StyledPageWrapper = styled(PageWrapper)`
  @media all and (min-width: 1900px) {
    max-width: 180rem;
  }
`
